const getPromos = content =>
  content.mainContent
    ? content.mainContent.filter(
        paragraph =>
          paragraph.entity && paragraph.entity.type === 'ParagraphPromo'
      )
    : null;

const getDataSubdirectory = (id, includeSeparator = true) => {
  const thousands = id >= 10000 ? Math.floor(id / 10000) * 10000 : null;
  return includeSeparator ? `${thousands}/` : thousands;
};

module.exports = {
  getPromos,
  getDataSubdirectory
};
